import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { dateFormat, getDateTime } from "utils/date";

//공지사항 관리
export default function NoticeManagementComponent() {
  const itemsPerPage = 100;
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState(null);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    setFormDataProperty("title", "");
    setFormDataProperty("content", "");
    setFormDataProperty("isPublic", "true");
    setFormDataProperty("startDate", "");
    setFormDataProperty("endDate", "");
    setFormDataProperty("isDomainSpecific", "false");
    setFormDataProperty("domainStartDate", "");
    setFormDataProperty("domainEndDate", "");
    setFormDataProperty("files", []);

    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getNoticePostListByUrl(url);
      } else {
        result = await dbmsApi.getNoticePostList(
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const newFiles = e.target.files;
      if (newFiles.length > 0) {
        setFormDataProperty("files", [...formData.files, ...newFiles]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const openRegistModal = () => {
    setFormDataProperty("title", "");
    setFormDataProperty("content", "");
    setFormDataProperty("isPublic", "true");
    setFormDataProperty("startDate", "");
    setFormDataProperty("endDate", "");
    setFormDataProperty("isDomainSpecific", "false");
    setFormDataProperty("domainStartDate", "");
    setFormDataProperty("domainEndDate", "");
    setFormDataProperty("files", []);

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeRegistModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.results.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteNoticePost(checkedIds);
      alert(`${data}`)

      //삭제 성공 시 새로고침
      if (status === true) {
        closeDelModal();
        getData(page);
      }
    });
  }

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  }

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  }

  const handleDeleteFile = (e) => {
    setFormDataProperty("files", formData.files.filter(item => item !== e));
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        if (formData.files.length > 0) {
          formData.files.map((file) => {
            requestBody.append("files", file);
          });
        }
        requestBody.append("payload",
          JSON.stringify({
            title: formData.title,
            content: formData.content,
            isPublic: true,
            startDate: formData.startDate,
            endDate: formData.endDate,
            isDomainSpecific: formData.isDomainSpecific,
            domainStartDate: formData.domainStartDate === "" ? null : formData.domainStartDate,
            domainEndDate: formData.domainEndDate === "" ? null : formData.domainEndDate,
          }));

        const { status, data } = await dbmsApi.addNoticePost(requestBody);
        if (status === true) {
          alert(`저장을 완료하였습니다.`);
          closeRegistModal();
          getData(page);
        } else {
          alert(`저장을 실패하였습니다.\n${data}`)
        }
      });
    }
  }

  const checkValid = () => {
    return true;
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard NMBoard">
        <div class="top_board pc">
          <p class="title_board">공지사항 관리</p>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">공지사항 관리</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board ">
          <table class="admin-table uam-table">
            <colgroup>
              <col width="5%" />
              <col width="8%" />
              <col width="30%" />
              <col width="8%" />
              <col width="15%" />
              <col width="8%" />
              <col width="8%" />
              <col width="8%" />
              <col width="10%" />
              <col width="10%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <input type="checkbox" name="" id="" onChange={handleCheckAll} />
                </th>
                <th class="admin-th">
                  관리ID
                </th>
                <th class="admin-th">
                  제목
                </th>
                <th class="admin-th">
                  작성자
                </th>
                <th class="admin-th">
                  <p>작성일시</p>
                </th>
                <th class="admin-th">
                  <p>게시 시작일 </p>
                </th>
                <th class="admin-th">
                  <p>게시 종료일</p>
                </th>
                <th class="admin-th">
                  <p>도메인 화면표시</p>
                </th>
                <th class="admin-th">
                  <p>도메인 화면표시<br />시작일</p>
                </th>
                <th class="admin-th">
                  <p>도메인 화면표시<br />종료일</p>
                </th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource.results &&
                dataSource.results.map((item, index) => (
                  <tr class="admin-tr wrap_table_item">
                    <td class="admin-td">
                      <input type="checkbox" name="" id="" checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeCheck(e, item.id)} />
                    </td>
                    <td class="admin-td">
                      <p>{item.id}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.title}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.authorUserId}</p>
                    </td>
                    <td class="admin-td">
                      <p>{getDateTime(new Date(item.createdDate))}</p>
                    </td>
                    <td class="admin-td">
                      <p>{dateFormat(new Date(item.startDate))}</p>
                    </td>
                    <td class="admin-td">
                      <p>{dateFormat(new Date(item.endDate))}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.isDomainSpecific === true ? 'Y' : 'N'}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.domainStartDate !== null ? dateFormat(new Date(item.domainStartDate)) : ''}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.domainEndDate !== null ? dateFormat(new Date(item.domainEndDate)) : ''}</p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn btn_save" onClick={openRegistModal}>등록</button>
            <button class="item_btn" id="deleteBtn" onClick={openDelModal}>삭제</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>삭제</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeRegistModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeRegistModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>공지사항 작성</h2>
              {formData && (
                <div class="wrap_detail_cont veiw_radio_cont">
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">제목</p>
                    <div class="detail_box">
                      <input class="default_input" type="text" placeholder="제목을 입력해주세요." name="title" value={formData.title} onChange={onChange} />
                    </div>
                  </div>
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">내용</p>
                    <div class="detail_box">
                      <textarea class="detail_textarea" placeholder="내용을 입력해주세요." name="content" value={formData.content} onChange={onChange}></textarea>
                    </div>
                  </div>
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">공개 여부</p>
                    <div class="detail_box detail-duble-box">
                      <div class="radio-wrap">
                        <label for="radio_1" class="radio-item">
                          <input type="radio" id="radio_1" class="form-radio" name="isPublic" value="true" checked={formData.isPublic === "true"} onChange={onChange} />
                          <span class="radio-icon">
                            <i class="xi-check"></i>
                          </span>
                          <p class="radio-title">공개</p>
                        </label>
                        <label for="radio_2" class="radio-item">
                          <input type="radio" id="radio_2" class="form-radio" name="isPublic" value="false" checked={formData.isPublic === "false"} onChange={onChange} />
                          <span class="radio-icon">
                            <i class="xi-check"></i>
                          </span>
                          <p class="radio-title">비공개</p>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">게시일자/종료일자</p>
                    <div class="detail_box detail_date_box date-wrap">
                      <div className={`date-input-wrap ${formData.startDate ? "selected" : ""}`} onChange={onChange}>
                        <p class="date-title" style={{ display: formData.startDate ? "none" : "block" }}>{formData.startDate || '게시일자 년-월-일'}</p>
                        <input type="date" class="form-input" id="start_date" name="startDate" value={formData.startDate} />
                      </div>
                      <div className={`date-input-wrap ${formData.endDate ? "selected" : ""}`} onChange={onChange}>
                        <p class="date-title" style={{ display: formData.endDate ? "none" : "block" }}>{formData.endDate || '종료일자 년-월-일'}</p>
                        <input type="date" class="form-input" id="end_date" name="endDate" value={formData.endDate} />
                      </div>
                    </div>
                  </div>
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">도메인 게시 여부</p>
                    <div class="detail_box detail-duble-box">
                      <div class="radio-wrap">
                        <label for="radio_3" class="radio-item">
                          <input type="radio" id="radio_3" class="form-radio" name="isDomainSpecific" value="true" checked={formData.isDomainSpecific === "true"} onChange={onChange} />
                          <span class="radio-icon">
                            <i class="xi-check"></i>
                          </span>
                          <p class="radio-title">게시</p>
                        </label>
                        <label for="radio_4" class="radio-item">
                          <input type="radio" id="radio_4" class="form-radio" name="isDomainSpecific" value="false" checked={formData.isDomainSpecific === "false"} onChange={onChange} />
                          <span class="radio-icon">
                            <i class="xi-check"></i>
                          </span>
                          <p class="radio-title">게시안함</p>
                        </label>
                      </div>
                    </div>
                  </div>
                  {formData.isDomainSpecific === "true" && (
                    <div class="wrap_detail_item default_type_item">
                      <p class="title_detail">도메인 게시 시작일자/종료일자</p>
                      <div class="detail_box detail_date_box date-wrap">
                        <div className={`date-input-wrap ${formData.domainStartDate ? "selected" : ""}`} onChange={onChange}>
                          <p class="date-title" style={{ display: formData.domainStartDate ? "none" : "block" }}>{formData.domainStartDate || '게시일자 년-월-일'}</p>
                          <input type="date" class="form-input" id="domain_start_date" name="domainStartDate" value={formData.domainStartDate} />
                        </div>
                        <div className={`date-input-wrap ${formData.domainEndDate ? "selected" : ""}`} onChange={onChange}>
                          <p class="date-title" style={{ display: formData.domainEndDate ? "none" : "block" }}>{formData.domainEndDate || '종료일자 년-월-일'}</p>
                          <input type="date" class="form-input" id="domain_end_date" name="domainEndDate" value={formData.domainEndDate} />
                        </div>
                      </div>
                    </div>
                  )}
                  <div class="file-wrapper">
                    <p>첨부파일</p>
                    <div class="file-input">
                      <label for="file-upload" class="file-upload-btn">+</label>
                      <input type="file" id="file-upload" class="file-upload-input" name="files" multiple onChange={onChange} />
                    </div>
                    <div class="file-name-container">
                      {formData.files.map((item, index) => (
                        <div class="file-item">
                          <span id="file-name">{item.name}</span>
                          <button type="button" id="remove-btn" class="remove-btn" onClick={() => handleDeleteFile(item)}>X</button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <button type="submit" class="btn_dark">저장</button>
                </div>
              )}
            </form>
          </div>
        )}

      </div >
    </>
  );
}
